var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rates-additional-info"},_vm._l((_vm.row.flatMap(function (r) { return r.rateData.rate.weekdays; })),function(wd,i){return _c('span',{key:i,staticClass:"ml-1 mr-1"},[_vm._v(_vm._s(wd.short)),((i + 1) % 3 === 0)?_c('br'):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b199601","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalcRatesTableCellWeekdays.vue
// module id = null
// module chunks = 